import { Checkbox } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/solid";
import { getBonzahProducts } from "api/bonzah/bonzah";
import { tripModificationRequest } from "api/booking/booking";
import { useData } from "data/data-provider";
import { globalJson } from "global/global_json";
import React, { FC, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import Badge from "shared/Badge/Badge";

interface InsuranceandExtrasProp {
  bookingDetails: any;
}

const InsuranceandExtras: FC<InsuranceandExtrasProp> = ({ bookingDetails }) => {
  const {
    setSelectedBonzahProducts,

    setSelectedExtras,
    bookingdetails,
    selectedExtras,
    selectedCar,
    selectedBonzahProducts,
    bonzahProducts,
  } = useData();
  const [loading, setLoading] = useState(false);
  const handleBonzahProductSelection = (productType: any) => {
    setSelectedBonzahProducts(productType);
  };

  const renderDescriptionWithLink = (description: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = description.split(urlRegex);
    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  const handleExtraChange = (extraId: any, checked: any) => {
    setSelectedExtras((prevSelectedExtras) => {
      const updatedExtras = new Set(prevSelectedExtras);
      if (checked) {
        updatedExtras.add(extraId);
      } else {
        updatedExtras.delete(extraId);
      }
      return updatedExtras;
    });
  };

  useEffect(() => {
    if (selectedCar?.extras) {
      const requiredExtras = selectedCar.extras
        .filter((extra: any) => extra.is_required)
        .map((extra: any) => extra.id);

      setSelectedExtras((prevSelectedExtras: Set<any>) => {
        const updated = new Set(prevSelectedExtras);
        requiredExtras.forEach((id) => updated.add(id));
        return updated;
      });
    }
  }, [selectedCar?.extras, setSelectedExtras]);

  useEffect(() => {
    if (selectedCar && 
        Array.isArray(selectedCar.allowed_insurances) && 
        Array.isArray(selectedBonzahProducts) && 
        selectedBonzahProducts.length > 0) {
      if (selectedCar.allowed_insurances.includes("all")) {
        return;
      }
      const filteredInsurances = selectedBonzahProducts.filter(insurance => 
        Array.isArray(selectedCar.allowed_insurances) && selectedCar.allowed_insurances.includes(insurance)
      );
      if (filteredInsurances.length !== selectedBonzahProducts.length) {
        setSelectedBonzahProducts(new Set(filteredInsurances));
      }
    }
  }, [selectedCar, selectedBonzahProducts, setSelectedBonzahProducts]);
  useEffect(() => {
    if (selectedCar?.extras && selectedExtras && selectedExtras.size > 0) {
      const availableExtraIds = selectedCar.extras.map((extra: any) => extra.id);
      let needsUpdate = false;
      const filteredExtras = new Set<any>();
      selectedExtras.forEach((extraId: number) => {
        if (availableExtraIds.includes(extraId)) {
          filteredExtras.add(extraId);
        } else {
          needsUpdate = true;
        }
      });
      if (needsUpdate) {
        setSelectedExtras(filteredExtras);
      }
    }
  }, [selectedCar?.extras, selectedExtras, setSelectedExtras]);

  const insuranceNotAllowed =
    Array.isArray(bookingDetails?.bonzah_insurance_options) &&
    Array.isArray(selectedCar?.allowed_insurances) &&
    selectedCar &&
    !selectedCar.allowed_insurances.includes("all") &&
    bookingDetails.bonzah_insurance_options.some(
      (id: any) =>
        !Array.isArray(selectedCar.allowed_insurances) ||
        !selectedCar.allowed_insurances.includes(id)
    );

  const extrasNotAllowed =
    Array.isArray(bookingDetails?.extras) &&
    bookingDetails.extras.length > 0 &&
    Array.isArray(selectedCar?.extras) &&
    selectedCar &&
    bookingDetails.extras.some(
      (extra: any) => !selectedCar.extras.find((e: any) => e.id === extra.id)
    );

  const showBanner = insuranceNotAllowed || extrasNotAllowed;

  const renderBonzahSection = () => {
    return (
      <>
       
        <div className="listingSection__wrap">
          <h2 className="text-2xl text-text-color  font-bold">
            Trip Insurance
          </h2>
          {bonzahProducts?.insurance_options
            ?.filter((product: any) => !(product.insurance_by_bonzah === true))
            .map((product: any) => (
              <div
                key={product.title}
                className="flex flex-col justify-between items-start  border border-secondary-100 rounded-md p-4 max-w-full overflow-hidden"
              >
                <div className="flex items-start">
                  <Checkbox
                    checked={
                      Array.isArray(selectedBonzahProducts) &&
                      product?.value?.some((val: any) =>
                        selectedBonzahProducts.includes(val)
                      )
                    }
                    onChange={() =>
                      handleBonzahProductSelection(product?.value)
                    }
                    className="group size-7 rounded-md p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                  >
                    <CheckIcon
                      className={`size-5 stroke-primary-200 ${
                        Array.isArray(selectedBonzahProducts) &&
                        product?.value?.some((val: any) =>
                          selectedBonzahProducts.includes(val)
                        )
                          ? "visible"
                          : "invisible"
                      }`}
                    />
                  </Checkbox>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center mb-2">
                      <h2 className="text-lg md:text-xl font-bold text-text-color">
                        {product.title}
                      </h2>
                      {product?.pdf !== "" && (
                        <button
                          className="ml-2 text-text-color"
                          onClick={() => window.open(product.pdf, "_blank")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fill="#1B2430"
                              d="M9.997 18.958c-4.941 0-8.958-4.016-8.958-8.958s4.017-8.958 8.958-8.958c4.942 0 8.959 4.016 8.959 8.958s-4.017 8.958-8.959 8.958Zm0-16.666C5.747 2.292 2.29 5.75 2.29 10s3.458 7.708 7.708 7.708S17.706 14.25 17.706 10s-3.459-7.708-7.709-7.708Z"
                            />
                            <path
                              fill="#1B2430"
                              d="M10 11.458a.63.63 0 0 1-.625-.625V6.667A.63.63 0 0 1 10 6.042a.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625Zm-.003 2.709a.829.829 0 0 1-.316-.067.963.963 0 0 1-.275-.175.86.86 0 0 1-.175-.275.83.83 0 0 1-.067-.317.83.83 0 0 1 .067-.316c.041-.1.1-.192.175-.275a.96.96 0 0 1 .275-.175.833.833 0 0 1 .633 0c.1.041.192.1.275.175a.963.963 0 0 1 .175.275.83.83 0 0 1 .067.316.83.83 0 0 1-.067.317.86.86 0 0 1-.175.275.964.964 0 0 1-.275.175.83.83 0 0 1-.317.067Z"
                            />
                          </svg>
                        </button>
                      )}
                    </div>

                    {product?.options &&
                      Object.entries(product.options).map(([key, values]) => (
                        <div key={key} className="mt-2">
                          {!product.canopy && product.insurance_by_bonzah && (
                            <h3 className="font-semibold text-text-color uppercase truncate">
                              {key}
                            </h3>
                          )}

                          <p className="lg:text-lg text-md text-text-color break-words">
                            {(Array.isArray(values) ? values : [values]).map(
                              (detail, index) => {
                                // If detail is HTML from Quill editor, render as HTML but make links clickable
                                if (
                                  typeof detail === "string" &&
                                  detail.trim().startsWith("<")
                                ) {
                                  // Replace URLs in HTML with anchor tags if not already wrapped
                                  const urlRegex = /(https?:\/\/[^\s<>"']+)/g;
                                  let html = detail.replace(urlRegex, (url) => {
                                    // If already inside an anchor tag, skip
                                    if (detail.includes(`<a href="${url}`))
                                      return url;
                                    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${url}</a>`;
                                  });
                                  return (
                                    <span
                                      key={index}
                                      className={
                                        product.canopy
                                          ? "text-red-500 font-semibold"
                                          : ""
                                      }
                                      style={{ wordBreak: "break-word" }}
                                      dangerouslySetInnerHTML={{ __html: html }}
                                    />
                                  );
                                }
                                // If detail contains a URL, make it clickable
                                const urlRegex = /(https?:\/\/[^\s]+)/g;
                                if (
                                  typeof detail === "string" &&
                                  urlRegex.test(detail)
                                ) {
                                  const parts = detail.split(urlRegex);
                                  return (
                                    <span
                                      key={index}
                                      className={
                                        product.canopy
                                          ? "text-red-500 font-semibold"
                                          : ""
                                      }
                                      style={{ wordBreak: "break-word" }}
                                    >
                                      {parts.map((part, i) =>
                                        urlRegex.test(part) ? (
                                          <a
                                            key={i}
                                            href={part}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-500 hover:underline"
                                            style={{ wordBreak: "break-word" }}
                                          >
                                            {part}
                                          </a>
                                        ) : (
                                          <React.Fragment key={i}>
                                            {part}
                                          </React.Fragment>
                                        )
                                      )}
                                      <br />
                                    </span>
                                  );
                                }
                                // Otherwise, render as plain text
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {detail}
                                    <br />
                                  </span>
                                );
                              }
                            )}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>

                <div className="mt-4 md:mt-0 w-full flex justify-end items-center">
                  <p className="lg:text-2xl text-lg font-bold text-text-color">
                    ${product.price.toFixed(2)}
                    <span className="text-text-color lg:text-lg">
                      /
                      {product.nature === "per_trip"
                        ? "trip"
                        : product.nature === "per_day"
                        ? "day"
                        : "24 hours"}
                    </span>
                  </p>
                </div>
              </div>
            ))}
        </div>
      </>
    );
  };

  const renderExtrasSection = () => {
    return (
      <div className="listingSection__wrap !mb-10 mt-4">
        <h2 className="text-2xl font-bold text-text-color ">Extras</h2>

        {selectedCar?.extras.map((extra) => (
          <div
            key={extra.id}
            className="w-full rounded-md border border-secondary-100 flex justify-between items-center p-5"
          >
            <div className="flex justify-start">
              <Checkbox
                checked={selectedExtras?.has(extra.id)}
                onChange={(checked) => {
                  if (!extra.is_required) {
                    handleExtraChange(extra.id, checked);
                  }
                }}
                className="group size-7 rounded-md  p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                disabled={extra.is_required}
              >
                <CheckIcon
                  className={`size-5 stroke-primary-200 ${
                    selectedExtras.has(extra.id) ? "visible" : "invisible"
                  }`}
                />
              </Checkbox>
              <div>
                <div className="text-text-color lg:text-lg sm:text-l font-bold flex space-x-2">
                  <span>{extra.name}</span>
                  {extra.is_required && <Badge color="blue" name="Required" />}
                  {extra.is_recommended === true && (
                    <Badge color="blue" name="Recommended" />
                  )}
                </div>
                <div className="text-text-color lg:text-lg sm:text-md font-medium ">
                  {renderDescriptionWithLink(extra.description)}
                </div>
              </div>
            </div>

            <div className="mt-4 md:mt-0">
              <p className="lg:text-2xl text-lg font-bold text-text-color flex justify-end items-center">
                ${extra.amount}
                <span className="text-text-color lg:text-lg">
                  {" "}
                  /{extra?.nature === "per_day" ? "day" : "trip"}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      <div className="mt-12">
         {showBanner && (
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4 rounded">
            <div className="flex items-center">
              <svg
                className="h-6 w-6 text-yellow-500 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M12 20h.01"
                />
              </svg>
              <span>
                Previously selected insurance and extras are unavailable for the
                new fleet. Please choose new options
              </span>
            </div>
          </div>
        )}
        {bookingDetails?.bonzah_insurance_options !== null &&
          bonzahProducts?.insurance_options &&
          bonzahProducts.insurance_options.length > 0 &&
          renderBonzahSection()}
        {selectedCar?.extras &&
          selectedCar.extras.length > 0 &&
          renderExtrasSection()}
      </div>
    </div>
  );
};

export default InsuranceandExtras;
